module.exports = __webpack_public_path__ + "img/icon-work-4.1d7984b2.svg";